import { NoticeType } from './notice-type';

export class Notice {
    type?: NoticeType;
    text?: string;

    static info(text: string): Notice {
        return Notice.create(NoticeType.Info, text);
    }

    static error(text: string): Notice {
        return Notice.create(NoticeType.Error, text);
    }

    static warning(text: string): Notice {
        return Notice.create(NoticeType.Warning, text);
    }

    private static create(type: NoticeType, text: string): Notice {
        const notice = new Notice();
        notice.type = type;
        notice.text = text;
        return notice;
    }
}
